import { useState, useEffect } from "react";
import API from "../api";
import CreatePurchaseModal from "../components/CreatePurchaseModal";

function Purchase() {

  const [purchases, setPurchases] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [vendorFilter, setVendorFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");

  useEffect(() => {
    fetchPurchases();
  }, [vendorFilter, dateFilter]);

  const fetchPurchases = () => {

    let url = "order/purchase/purchase-list/?";

    if (vendorFilter) {
      url += `vendor=${vendorFilter}&`;
    }

    if (dateFilter) {
      url += `date=${dateFilter}`;
    }

    API.get(url).then(res => setPurchases(res.data));
  };

  return (
    <div className="container-fluid h-100">

      <div className="row h-100">

        <div className="col-12 d-flex flex-column h-100">

          {/* HEADER + FILTERS */}
          <div className="p-3 border-bottom">

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Purchases</h5>
              <button
                className="btn btn-sm btn-primary"
                onClick={() => setShowModal(true)}
              >
                + New Purchase
              </button>
            </div>

            <div className="row g-2">

              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Filter by vendor..."
                  value={vendorFilter}
                  onChange={e => setVendorFilter(e.target.value)}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={dateFilter}
                  onChange={e => setDateFilter(e.target.value)}
                />
              </div>

              <div className="col-md-2">
                <button
                  className="btn btn-sm btn-outline-secondary w-100"
                  onClick={() => {
                    setVendorFilter("");
                    setDateFilter("");
                  }}
                >
                  Clear
                </button>
              </div>

            </div>

          </div>

          {/* SCROLLABLE LIST */}
          <div style={{ flex: 1, overflowY: "auto" }}>
            <div className="p-3">

              {purchases.length === 0 && (
                <div className="text-center text-muted p-3">
                  No purchases found
                </div>
              )}

              {purchases.map((group, index) => (
                <div key={index} className="card mb-3">

                  <div className="card-header d-flex justify-content-between align-items-center bg-light">
                    <div>
                      <strong>{group.vendor_name}</strong>
                      <span className="text-muted ms-2 small">
                        {group.purchase_date}
                      </span>
                    </div>
                    <span className="badge bg-secondary">
                      {group.items.reduce((total, item) => total + parseInt(item.quantity || 0, 10), 0)} Sheets
                    </span>
                  </div>

                  <div className="card-body p-0">
                    <table className="table table-sm mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="ps-3">Sheet</th>
                          <th width="100">Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {group.items.map((item, i) => (
                          <tr key={i}>
                            <td className="ps-3">{item.sheet_name}</td>
                            <td>{item.quantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                </div>
              ))}

            </div>
          </div>

        </div>

      </div>

      {showModal && (
        <CreatePurchaseModal
          onClose={() => setShowModal(false)}
          refreshPurchases={fetchPurchases}
        />
      )}

    </div>
  );
}

export default Purchase;
